import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import 'moment-timezone';

@Pipe({name: 'moment'})
export class MomentPipe implements PipeTransform {
  transform(value:string, args:string[]) : any {
    if(value === '' || value === undefined) {
      return '';
    }

    // twitter has some weird formatting after the 4 digit year
    try{
      value = String(value);
      if(value.indexOf('?') !== -1){
        value = value.substring(0, value.indexOf('?'));
      }
    }
    catch(err) {
      console.warn(err, value)
    }
    var conv_date: any = new Date(value);
    var pipe_date = moment(conv_date);
    var date_now = moment(Date.now());
    var diff: number;

    if(args.length > 0){
      if(args[0] == 'fromNow'){

        diff = Math.abs(pipe_date.diff(date_now, 'days'));
        if(diff > 1){
          return pipe_date.format('LLL');
        } else if(diff <= 0){
          return 'Ended ' + pipe_date.fromNow();
        } else {
          return pipe_date.fromNow();
        }
      }
      else if(args[0] == 'timeSince'){
        diff = Math.abs(pipe_date.diff(date_now, 'days'));
        if(diff > 1){
          return pipe_date.format('LLL');
        }else {
          return pipe_date.fromNow();
        }
      }
      else if(args[0] == 'daysFromNow'){
        diff = pipe_date.diff(date_now, 'days');
        if(diff > 1){
          return 'Ends ' + pipe_date.fromNow();
        } else {
          diff = pipe_date.diff(date_now, 'hours');
          if(diff > 1) {
            return 'Ends ' + pipe_date.fromNow();
          }
          else {
            diff = pipe_date.diff(date_now, 'minutes');
            if(diff > 1) {
              return 'Ends ' + pipe_date.fromNow();
            }
            else {
              diff = pipe_date.diff(date_now, 'seconds');
              if(diff > 1) {
                return 'Ends ' + pipe_date.fromNow();
              } else {
                return 'Ended';
              }
            }
          }
        }
      }
      else if(args[0] == 'prettyDisplay'){
        return pipe_date.format('dddd, MMMM D, YYYY') + ' at ' + pipe_date.format('hh:mm A z');
      }
      else if(args[0] == 'noTime'){
        return pipe_date.format('LL')
      }
      else if(args[0] == 'basicWithTime'){
        return pipe_date.format('MM/DD/YYYY h:mm A')
      }
      else if(args[0] == 'basic'){
        return pipe_date.format('L');
      }
      else if(args[0]){
        return pipe_date.format(args[0]);
      }
    }
    return pipe_date.format('LLL');
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/pipes/moment.ts